import { render, staticRenderFns } from "./selfSonItem.vue?vue&type=template&id=ec82bc4c&scoped=true&"
import script from "./selfSonItem.vue?vue&type=script&lang=ts&"
export * from "./selfSonItem.vue?vue&type=script&lang=ts&"
import style0 from "./selfSonItem.vue?vue&type=style&index=0&id=ec82bc4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec82bc4c",
  null
  
)

export default component.exports